import { connect, getLocale, useIntl, history } from 'umi';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Layout, Card, Table, Bubble, PagingQuery, ConfigProvider } from 'tea-component';
import { useSubscribeManagerTableMap } from './_config/constant';
import { formatUTC8Time, getUTCTime, getFrequencyStr } from './_config/utils';
import { useBuriedPoint } from '@/pages/home/utils/customHook';
import { useRequest } from '../../utils/customHook';
import { getsubscribeRecordTable } from '../../services/substribe';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { RANGE_DAILY_TYPE } from '../../components/NewFilter/FilterBase/_config';
import { LANGUAGE_CN } from '../../_config/constant';
import RangePicker from '@/pages/home/components/RangePicker';

import '@/pages/dashboard/assets/scss/page/Subscribe/subscribe.scss';
import '@/pages/dashboard/assets/scss/page/Subscribe/subscribeManage.scss';

const { Body, Content } = Layout;
const { pageable, autotip } = Table.addons;

const SubscribeRecord = (props: any) => {
  const { gameCode } = props;
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const { sendRequest, isLoading: loading, isError: error } = useRequest();
  const { PUSH_RESULT, WEEK_TEXT, TIME_TEXT } = useSubscribeManagerTableMap();
  const state: any = history.location.query || { frequency: '', id: '', title: '' };
  const { id, title, frequency_interval, frequency_time, frequency_type } = state;
  const defaultTimeVal = [moment().subtract(30, 'days'), moment()];
  const [time, setTime] = useState(defaultTimeVal);
  // 分页
  const [paging, setPaging] = useState<PagingQuery>({ pageSize: 10, pageIndex: 1 });
  // 总条数
  const [total, setTotal] = useState(0);
  // 表格数据
  const [tableData, setTableData] = useState([]);

  // 打点信息
  const logObj = {
    pageId: '202401',
    pageName: 'subscribeRecord',
    extInfo: 'subscribeRecord',
    pagePath: '/subscribe/subscribeRecord',
    uid: gameCode,
    uidType: 'game_code'
  };
  useBuriedPoint(logObj);

  const getTableData = async (param?:any) => {
    const start_time = formatUTC8Time(moment(time[0]).format('YYYY-MM-DD HH:mm:ss'));
    const end_time = formatUTC8Time(moment(time[1]).format('YYYY-MM-DD 23:59:59'));
    const params = {
      start_time,
      end_time,
      subscribe_id: id,
      page: paging?.pageIndex || 1,
      page_size: paging?.pageSize || 10,
      ...param
    };
    setTableData([]);
    try {
      const result = await sendRequest(getsubscribeRecordTable(params));
      const newTableData = (result?.list || [])?.map(item=> {
        const receiversNum = item?.receivers?.split(',')?.length;
        return { ...item, receiversNum };
      });
      setTableData(newTableData);
      setTotal(result?.total);
    } catch (error) {
      console.log('error', error);
    }
  };
  useEffect(() => {
    getTableData();
  }, []);

  const frequency = getFrequencyStr({ frequency_interval, frequency_time, frequency_type: Number(frequency_type) }, formatMessage, WEEK_TEXT, TIME_TEXT);

  return (
    <Layout>
      <Body>
        <ConfigProvider locale={locale==='zh-CN'?'zh':"en"}>
          <Content className='dbd-subscribemanage dbd-subscribe-history'>
            <Content.Header
              showBackButton
              onBackButtonClick={() => {
                history.goBack();
              }}
              title={<div className='dbd-subscribe-record-title'>【{title}】【{frequency}】{formatMessage({ id: "subscribe_record_push_history" })}</div>}
            >
            </Content.Header>
            <Content.Body full>
              <div className='subscribemanage-search search-item search-item-date subscribemanage-search-record'>
                <RangePicker
                  type='date'
                  value={time}
                  startOfTime='2017-01-01'
                  className=""
                  typeList={RANGE_DAILY_TYPE}
                  showSelectType={false}
                  showShortcut={false}
                  language={locale === LANGUAGE_CN ? 'cn' : 'en'}
                  onChange={(value: any) => {
                    setTime(value);
                    setPaging({ pageSize: paging?.pageSize, pageIndex: 1 });
                    const start_time = moment(value[0]).format('YYYY-MM-DD HH:mm:ss');
                    const end_time = moment(value[1]).format('YYYY-MM-DD 23:59:59');
                    const param = {
                      start_time,
                      end_time,
                      page: 1,
                      page_size: paging?.pageSize,
                    };
                    getTableData(param);
                  }}
                />
              </div>
              <Card className='dbd-subscribemanage-table'>
                <Card.Body>
                  <Table
                    className="dbd-subscribe-table"
                    records={tableData}
                    columns={[
                      {
                        key: "receivers",
                        header: formatMessage({ id: "subscribe_record_receivers" }),
                        render: (record: any) => {
                          const countryArr = record?.receivers?.split(',');
                          const contryLength = countryArr?.length;
                          const countryLenFlag = contryLength > 3;

                          const countryRenderArr = countryLenFlag ? countryArr?.slice(0, 3) : countryArr;
                          const countryRenderStr = countryRenderArr?.join(", ");

                          return (
                            <div className='receiver'>
                              {
                                countryLenFlag ?

                                  <Bubble
                                    arrowPointAtCenter
                                    placement="top"
                                    dark
                                    content={countryArr?.join(',')}
                                  >
                                    {
                                      locale !== LANGUAGE_CN ? `${countryRenderStr},etc.(${contryLength})` :
                                        `${countryRenderStr},等${contryLength}个收件人`
                                    }
                                  </Bubble>
                                  : countryRenderStr
                              }
                            </div>
                          );
                        }
                      },
                      {
                        key: "send_status",
                        header: formatMessage({ id: "subscribe_record_send_status" }),
                        width: 156,
                        render: record => {
                          const result = PUSH_RESULT[record?.send_status];
                          // 0：未推送 1:推送成功 2:推送失败 3:部分推送成功 4：推送中
                          return <div className='table-flex'>
                            {/* 迁移重构的代码结构,并优化判断逻辑 */}
                            <div className={result?.className}>{result?.text}</div>
                            {
                              record?.send_status == '3' ? <Bubble content={
                                <div className='dbd-table-topic'>
                                  <div className='dbd-table-topic-title'>{formatMessage({ id: "subscribe_manager_push_result_fail_info" })}</div>
                                  <div className='dbd-table-topic-text'>{record?.receiver_fail?.replace(",", "，")}</div>
                                </div>
                              } dark>
                                <div className='dbd-table-topic-icon'>
                                  <TipContext />
                                </div>
                              </Bubble> : ''
                            }
                          </div>;
                        },
                      },
                      {
                        key: "last_push_time",
                        header: formatMessage({ id: "subscribe_record_last_push_time" }),
                        render: (cvm) => <div className='table-text'>{getUTCTime(cvm?.last_push_time)}</div>
                      },
                    ]}
                    addons={[
                      autotip({
                        isLoading: loading,
                        isError: Boolean(error),
                        loadingText: formatMessage({ id: "common_loading" }), // 加载文案
                        emptyText: formatMessage({ id: "common_nodata" }), // 空数据文案
                        errorText: formatMessage({ id: "common_loading_failed" }),
                        retryText: formatMessage({ id: "common_retry_table" }), // 重试文案
                        onRetry: () => { getTableData() },
                        style: { lineHeight: '200px' },
                      }),
                      pageable({
                        recordCount: total,
                        pageIndex: paging.pageIndex || 1,
                        pageSize: paging.pageSize || 10,
                        stateText: total > 10 ? `${total} ${formatMessage({ id: 'common_records' })}` : '',
                        pageSizeOptions: [10, 20, 30, 40, 50],
                        onPagingChange(query) {
                        // 切换分页
                          setPaging(query);
                          const param = {
                            page: query?.pageIndex,
                            page_size: query?.pageSize,
                          };
                          // 发起请求
                          getTableData(param);
                        }
                      })
                    ]}
                  />
                </Card.Body>
              </Card>
            </Content.Body>
          </Content>
        </ConfigProvider>
      </Body>
    </Layout>
  );
};

export default connect((props: any) => ({
  gameCode: props.dashboard?.gameCode?.gameCode
}))(SubscribeRecord);
